/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
    Workspace,
    WorkspaceFromJSON,
    WorkspaceFromJSONTyped,
    WorkspaceToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspacesResponse
 */
export interface WorkspacesResponse {
    /**
     * 
     * @type {Array<Workspace>}
     * @memberof WorkspacesResponse
     */
    results: Array<Workspace>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof WorkspacesResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof WorkspacesResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof WorkspacesResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof WorkspacesResponse
     */
    hasPreviousPage?: boolean;
}

export function WorkspacesResponseFromJSON(json: any): WorkspacesResponse {
    return WorkspacesResponseFromJSONTyped(json, false);
}

export function WorkspacesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspacesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(WorkspaceFromJSON)),
        'listResult': json['listResult'],
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function WorkspacesResponseToJSON(value?: WorkspacesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(WorkspaceToJSON)),
        'listResult': value.listResult,
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}


